import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Edit, Lock, ExpandMore } from '@mui/icons-material';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import { composeLink, GAM_ORDER_PRIMARY, GAM_PROPOSAL_PRIMARY } from '../utils/link';
import { toCurrency } from '../utils/currency';
import { isLockedOrder } from '../utils/adManagerHelpers';
import NewBuyerDialog from "./NewBuyerDialog";

const styles = (theme) => ({
  link: {
    marginLeft: 30
  },
  flex: {
    flex: 1
  },
  form: {
    width: '100%'
  },
  menu: {
    width: 200
  },
  amount: {
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 13,
    marginTop: 5
  },
  leftIcon: {
    marginRight: theme.spacing(2),
    marginTop: 4
  },
  displayInline: {
    display: 'inline'
  },
  charCounter: {
    textAlign: 'right',
    padding: 0,
    margin: '-5px 0 0 0',
    color: 'rgba(0, 0, 0, 0.5)'
  }
});


class IoForm extends Component {

  state = {
    showBuyerDialog: false,
    billingTypes: this.props.constants ? this.props.constants.billingTypes.concat(['']) : [],
  };

  componentDidMount() {
    const {constants} = this.props;
    const billingTypes = constants ? constants.billingTypes.concat(['']) : [];
    this.setState({billingTypes: billingTypes});
  }

  handleNewBuyerClose = buyer => {
    const { onChange } = this.props;
    if (buyer) {
      onChange({ target: { name: 'buyerId', value: buyer.buyeraccountid } });
      onChange({ target: { name: 'buyerName', value: buyer.name } });
    // } else { HACK for dev only
    //  onChange({ target: { name: 'buyerId', value: '123456789' } });
    //  onChange({ target: { name: 'buyerName', value: 'Hearst' } });
    }
    this.setState({ showBuyerDialog: false });
  };

  showBuyer = () => {
    this.setState({ showBuyerDialog: true });
  };

  render() {
    const { showBuyerDialog, billingTypes } = this.state;
    const {
      order,
      advertiser,
      isLive,
      errors,
      classes,
      constants,
      onChange,
      onSelect,
      statusList,
      itemRemainder,
      expanded,
      isLocked,
      onToggleExpand
    } = this.props;

    let bu;
    if (order && order.Advertiser &&order.Advertiser.BusinessUnitId && constants && constants.businessUnits.find) {
      bu = order.Advertiser.BusinessUnitId;
    } else {
      bu = null;
    }
    const buName = bu ? bu.name : 'none';
    const ioTypes = constants ? constants.ioTypes : [];
    const creativeSources = constants ? constants.creativeSources : [];
    const packageTypes = constants ? constants.packageTypes : [];
    const childDirectedAds = constants ? constants.childDirectedAds : [];
    const st = order.start ? moment(order.start).format('MMM D, YYYY') : '';
    const en = order.end ? moment(order.end).format('MMM D, YYYY') : '';
    const dateRun = `${st} - ${en}`;
    const buyer = `${order.buyerName || ''} ${order.buyerId || ''}`;
    const newBuyerMsg = 'Type and select a new programmatic buyer by name or ID.';
    const icon = isLocked ?
        <Tooltip title={"order is locked, editing is disabled"}>
          <Lock className={classes.leftIcon}/>
        </Tooltip> :
        <Edit className={classes.leftIcon}/>;

    return (
      <div>
        {showBuyerDialog && (
          <NewBuyerDialog
            message={newBuyerMsg}
            buyerExists={false}
            open
            onClose={this.handleNewBuyerClose}
            onSelect={onSelect}
          />
        )}
        {!showBuyerDialog && (
        <Accordion defaultExpanded={!order.id} expanded={expanded}
          onChange={(evt, expanded) => onToggleExpand(expanded)}>
          <AccordionSummary expandIcon={<ExpandMore />}>
            {icon}
            <Typography variant="h6" className={classes.flex}>
              {order.id ? order.agencyOrderName : `Create Order`}
              {order && order.orderType === 'Programmatic' && (
                <div className={classes.displayInline}>
                  <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                  <Chip label='Programmatic' />
                </div>
              )}
              {order.orderType === 'Programmatic' && (isLockedOrder(order)) && (
                <div className={classes.displayInline}>
                  <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                  <Chip label=' Finalized; changes may require Reopen' color="secondary" />
                </div>
              )}
              {order.orderType === 'Programmatic' && order.dfpReopenStatus && (
                <div className={classes.displayInline}>
                  <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                  <Chip label={order.dfpReopenStatus} color="secondary" />
                </div>
              )}
              {order.dfpOrderId && !order.dfpProposalId && (
              <Button
                target="_blank"
                href={composeLink(GAM_ORDER_PRIMARY, order)}
                className={classes.link}
                color="primary"
                size="small"
              >
                  Ad Manager ID: {order.dfpOrderId}
              </Button>
              )}
              {order.dfpProposalId && (
                <Button
                  target="_blank"
                  href={composeLink(GAM_PROPOSAL_PRIMARY, order)}
                  className={classes.link}
                  color="primary"
                  size="small"
                >
                  Ad Manager ID: {order.dfpProposalId}
                </Button>
              )}
              {itemRemainder < 1 && (
                <div className={classes.displayInline}>
                  <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
                  <Chip label="Line items at limit: actions adding more are prevented" color="secondary" />
                </div>
              )}
            </Typography>
            {advertiser.type !== 'Programmatic' && (
              <Typography className={classes.amount} variant="subtitle1">
                Unallocated packages: {toCurrency(order.unallocatedPkgs) || 0.00}
                <span>&nbsp; &nbsp; &nbsp; &nbsp;</span>
              </Typography>
            )}
            <Typography className={classes.amount} variant="subtitle1">
                Total amount: {toCurrency(order.totalOrderAmount)}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <form className={classes.form}>
              <Grid container spacing={3}>
                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    disabled
                    fullWidth
                    margin="normal"
                    label="Advertiser"
                    value={order.Advertiser.name}/>
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    disabled
                    fullWidth
                    margin="normal"
                    label="Business Unit"
                    value={buName} />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    disabled
                    fullWidth
                    margin="normal"
                    label="Account ID"
                    value={order.Advertiser.accountId} />
                </Grid>
                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    disabled
                    fullWidth
                    margin="normal"
                    label="Dates"
                    value={dateRun} />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    variant="standard"
                    fullWidth
                    select
                    name="childDirectedAds"
                    onChange={onChange}
                    margin="normal"
                    label="Child-Directed Ads"
                    value={order.childDirectedAds}
                    error={!!errors.childDirectedAds}
                    helperText={errors.childDirectedAds}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}>
                    {childDirectedAds.map(type => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={4}>
                  <TextField
                    variant="standard"
                    fullWidth
                    name="agencyOrderName"
                    onChange={onChange}
                    margin="normal"
                    label="Agency IO Name"
                    value={order.agencyOrderName}
                    error={!!errors.agencyOrderName}
                    helperText={errors.agencyOrderName} />
                  <p className={classes.charCounter}>{107 - order.agencyOrderName.length}/107</p>
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    disabled={isLive}
                    fullWidth
                    select
                    name="IoTypeId"
                    onChange={onChange}
                    margin="normal"
                    label="IO Type"
                    value={order.IoTypeId}
                    error={!!errors.IoTypeId}
                    helperText={errors.IoTypeId}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}>
                    {ioTypes.map(type => (
                      <MenuItem key={type.id} value={type.id}>
                        {type.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    fullWidth
                    select
                    name="packageType"
                    onChange={onChange}
                    margin="normal"
                    label="Default Package Type"
                    value={order.packageType}
                    error={!!errors.packageType}
                    helperText={errors.packageType}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}>
                    {packageTypes.map(type => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>

                {order.orderType !== 'Programmatic' &&
                (
                  <Grid item xs={4}>
                    <TextField
                      variant="standard"
                      disabled={!!order.IoStatus && order.IoStatusId === 5}
                      fullWidth
                      select
                      name="IoStatusId"
                      onChange={onChange}
                      margin="normal"
                      label="Order Status"
                      value={order.IoStatusId}
                      error={!!errors.IoStatusId}
                      helperText={errors.IoStatusId}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu
                        }
                      }}>
                      {statusList.map(status => (
                        <MenuItem key={status.id} value={status.id}>
                          {status.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )
                }

                {order.orderType === 'Programmatic' &&
                  (
                    <Grid item xs={4}>
                      <TextField
                        variant="standard"
                        disabled
                        fullWidth
                        margin="normal"
                        label="Proposal Status"
                        value={order.dfpProposalStatus} />
                    </Grid>
                  )
                }

                {order.orderType !== 'Programmatic' &&
                  (
                    <Grid item xs={2}>
                      <TextField
                        variant="standard"
                        fullWidth
                        margin="normal"
                        name="opportunityId"
                        onChange={onChange}
                        label="Opportunity ID"
                        value={order.opportunityId}
                        error={!!errors.opportunityId}
                        helperText={errors.opportunityId} />
                    </Grid>
                  )}

                {order.orderType !== 'Programmatic' && (
                  <Grid item xs={2}>
                    <TextField
                      variant="standard"
                      fullWidth
                      margin="normal"
                      name="opportunityName"
                      onChange={onChange}
                      label="Opportunity Name"
                      value={order.opportunityName}
                      error={!!errors.opportunityName}
                      helperText={errors.opportunityName} />
                  </Grid>
                )}
                {order.orderType !== 'Programmatic' &&
                (
                <Grid item xs={2}>
                  <TextField
                    variant="standard"
                    fullWidth
                    margin="normal"
                    name="agencyOrderId"
                    onChange={onChange}
                    label="Agency IO Id"
                    value={order.agencyOrderId}
                    error={!!errors.agencyOrderId}
                    helperText={errors.agencyOrderId} />
                  {order.agencyOrderId && <p className={classes.charCounter}>{20 - order.agencyOrderId.length}/20</p>}
                </Grid>
                )}

                {order.orderType !== 'Programmatic' &&
                  (
                  <Grid item xs={2}>
                    <TextField
                      variant="standard"
                      fullWidth
                      name="jagIoGroup"
                      onChange={onChange}
                      margin="normal"
                      label="IO Group"
                      value={order.jagIoGroup} />
                  </Grid>
                  )}
                {order.orderType !== 'Programmatic' &&
                (
                <Grid item xs={4}>
                  <TextField
                    variant="standard"
                    fullWidth
                    select
                    name="billingType"
                    onChange={onChange}
                    margin="normal"
                    label="Billing Type"
                    value={order.billingType || ''}
                    error={!!errors.billingType}
                    helperText={errors.billingType}
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu
                      }
                    }}>
                    {billingTypes.map(type => (
                      <MenuItem key={type} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </TextField>

                </Grid>
                )}
                <Grid item xs={8}>
                  {order.orderType === 'Programmatic' &&
                  (
                  <TextField
                    variant="standard"
                    fullWidth
                    margin="normal"
                    label="Buyer"
                    value={buyer}
                    onClick={this.showBuyer}
                    onFocus={this.showBuyer}
                    InputProps={{
                      readOnly: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton onClick={this.showBuyer} size="large"><Edit />
                          </IconButton>
                        </InputAdornment>
                      )
                    }} />
                  )
                  }
                </Grid>

                <Grid item xs={4}>
                  {order.orderType === 'Programmatic' && (
                    <TextField
                      variant="standard"
                      fullWidth
                      select
                      disabled={order.dfpProposalId && order.Placements && order.Placements.length > 0}
                      name="creativeSource"
                      onChange={onChange}
                      margin="normal"
                      label="Creative Source"
                      value={order.creativeSource || ''}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu
                        }
                      }}>
                      {creativeSources.map(type => (
                        <MenuItem key={type} value={type}>
                          {type}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Grid>
              </Grid>

            </form>
          </AccordionDetails>
        </Accordion>
      )}
      </div>
    );}

}

IoForm.defaultProps = {
  order: null
};

IoForm.propTypes = {
  order: PropTypes.object
};

export default withStyles(styles)(IoForm);
